/*
  Three.js
  by Fyrestar (https://sketchfab.com/mevedia)
  via https://sketchfab.com/3d-models/threejs-60320862bf904b7ab0e032c27daf7c7c

  License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
  Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & ObjectMap & { nodes: { Object_5: Mesh } }

export function ThreeLogo(props: JSX.IntrinsicElements['group']) {
  const { nodes } = useGLTF('/models/three-logo.glb') as GLTFResult

  return (
    <group {...props} dispose={null}>
      <mesh castShadow receiveShadow geometry={nodes.Object_5.geometry}>
        <meshStandardMaterial color="azure" metalness={1} roughness={0.35} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/three-logo.glb')
